import React, { Component } from "react";
import { Button, Icon, Modal, message } from "antd";
import ExportUtil from "../../../common/ExportUtil";
import API_URL from "../../../common/url";

class UploadModel extends Component {
    state={
        visible: false,
        uploadMes:{
            success:0,
            fail:0,
            error:0,
            errorFilePath:''
        },
    }

    show = uploadMes => {
        this.setState({ uploadMes, visible: true })
    }

    downErrorReport = ()=>{
        ExportUtil.export({}, null, API_URL.evaluate.getEvaluateVisitHourImportFailList);
        message.success('正在下载中!')
    }

    render() {
        const { visible, uploadMes } = this.state;
        return (
            <Modal 
                visible={visible}
                width={400}
                footer={null}
                closable={false}
                >
                <div style={{padding:'0 10px'}}>
                    <div style={{fontSize:'14px',fontWeight:'700',padding:'10px 0'}}><Icon type="exclamation-circle" style={{color:'#faad14',marginRight:'10px',fontSize:'20px'}}/>本次导入的“访视工时”数据:</div>
                    <div style={{paddingLeft:'30px'}}>
                        <p>导入成功{uploadMes.success}条</p>
                        <p>导入失败{uploadMes.fail}条</p>
                    </div>
                    {/* <p>数据错误{uploadMes.errorNum}条</p> */}
                    <div style={{textAlign:'right',marginTop:'20px'}}>
                        <Button size={ uploadMes.fail == 0 ? 'primary' : 'large' } style={{margin:'0 5px',fontSize:'12px'}} 
                        onClick={()=>{this.setState({visible:false})}}>{ uploadMes.fail == 0 ? '确定' : '关闭' }</Button>
                        {
                            uploadMes.fail != 0 &&
                            <Button type="primary" size='large' style={{margin:'0 5px',backgroundColor:'#169bd5',fontSize:'12px',borderColor:'#169bd5'}} onClick={() => this.downErrorReport()}>下载错误报告</Button>
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}

export default UploadModel


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitingHours/UploadModel.js